import React, { createRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_APPEND_CONVERSATIONS,
  SET_CONVERSATION_PAGE,
  SET_CONVERSATIONS_LOADING
} from "@iso/redux/chat/actions";
import Loading from "@iso/components/Loading/Loading";
import ChatDrawerSideBarItem from "@iso/components/ChatDrawer/ChatDrawerSideBarItem";

const NEXT_PAGE_STEP = 1;

const ChatDrawerSideBar = ({onClickConversation}) => {
  const dispatch = useDispatch();
  const { page, recordPerPage, selected, conversations, type, ...chat } = useSelector(state => state.chat);
  const sidebarRef = createRef();

  const setConversationNextPage = () => {
    dispatch({
      type: SET_CONVERSATION_PAGE,
      payload: page + NEXT_PAGE_STEP
    });
  }

  useEffect(() => {
   const fetchConversations = () => {
     dispatch({ type: SET_CONVERSATIONS_LOADING, payload: true })
     dispatch({
       type: FETCH_APPEND_CONVERSATIONS,
       payload: {
         page,
         recordPerPage,
         type
       }
     })
     dispatch({ type: SET_CONVERSATIONS_LOADING, payload: false })
   }

    if (conversations.length > 0) {
      fetchConversations();
    }
  }, [page, recordPerPage])

  const handleLoadMore = (e) => {
    if (!e?.currentTarget) return;
    if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop !== e.currentTarget.clientHeight) return;

    setConversationNextPage()
  }

  if (chat.isLoading) {
    return <div className='flex justify-center items-center w-full'>
      <Loading/>
    </div>
  }

  return (
    <div
      className='overflow-x-auto chat-sidebar chat-conversation'
      ref={sidebarRef}
      onScroll={handleLoadMore}
    >
      {
        Array.isArray(conversations) && conversations.map((conversation, index) => (
          <ChatDrawerSideBarItem key={index} onClick={onClickConversation} conversation={conversation} />
        ))
      }
      { chat.isLoading && <Loading />}
    </div>
  )
}

export default ChatDrawerSideBar;

